import React, { useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { EventImageType } from 'types/EventState';
import EventCoverImage from './EventCoverImage';

interface EventImageGalleryProps {
  coverImage: EventImageType | null;
  gallery: EventImageType[];
}

interface GalleryItem {
  original: string;
  small: string;
  originalHeight: number;
  loading?: 'lazy' | 'eager';
}

const EventImageGallery: React.FC<EventImageGalleryProps> = ({
  coverImage,
  gallery,
}) => {
  const [firstImageIsLoaded, setFirstImageIsLoaded] = useState(false);

  let galleryItems: GalleryItem[] = [];

  if (coverImage) {
    galleryItems.push({
      original: coverImage.original,
      small: coverImage.small,
      originalHeight: 450,
    });
  }

  for (let i = 0; i < gallery.length; i++) {
    galleryItems.push({
      original: gallery[i].original,
      small: gallery[i].small,
      originalHeight: 450,
      loading: 'lazy',
    });
  }

  useEffect(() => {
    const displayedImage = galleryItems[0].original;
    const img = new Image();
    img.src = displayedImage;
    img.onload = () => {
      setFirstImageIsLoaded(true);
    };
  }, []);

  return (
    <div
      id="event-image-gallery"
      className="mx-[-16px] md:mx-0 shadow-[0_2px_40px_rgba(0,0,0,0.32)] rounded-b-lg md:rounded-lg overflow-hidden"
    >
      {firstImageIsLoaded ? (
        <ImageGallery
          items={galleryItems}
          showFullscreenButton={false}
          showPlayButton={false}
          showBullets={true}
          slideInterval={6000}
        />
      ) : (
        <EventCoverImage image={galleryItems[0].small} />
      )}
    </div>
  );
};

export default EventImageGallery;
